<template>
  <div class="container">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <Breadcrumb-item class="breadcrumb-item">学习中心</Breadcrumb-item>
      <Breadcrumb-item class="breadcrumb-item-last">{{courseName}}</Breadcrumb-item>
      <Breadcrumb-item class="breadcrumb-item-last">串讲播放</Breadcrumb-item>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{currentVideoInfo.pptName}}</h1>
      </div>
    </div>

    <div class="video-container">
      <div class="clearfix video-wrap am-margin-top-lg">
        <div class="fl video-play">
          <video-player
            :width="770"
            :height="468"
            :viewId="umcrId"
            viewType="review"
            @on-over="playOver"
            :loading="!isLoaded"
          ></video-player>
        </div>
        <div class="fr video-catalog">
          <h3 class="video-catalog-header">串讲视频列表({{reviewVideoList.length}})</h3>
          <div class="video-catalog-wrap">
            <happy-scroll color="rgba(42,85,218,0.8)" resize hide-horizontal>
              <ul class="video-fav-list">
                <li
                  v-for="(item,index) in reviewVideoList"
                  :key="index"
                  :class="{active:pptId==item.pptId}"
                >
                  <div class="title-img">
                    <router-link
                      :to="{name:'ReviewVideo',query:{umcid:umcId,umcrid:umcrId,pptid:item.pptId}}"
                    >
                      <img :src="item.picFileName2" :alt="item.pptName" />
                    </router-link>
                  </div>
                  <div class="right-side">
                    <div class="video-title">
                      <router-link
                        :to="{name:'ReviewVideo',query:{umcid:umcId,umcrid:umcrId,pptid:item.pptId}}"
                      >{{item.pptName}}</router-link>
                    </div>
                    <div class="video-attr">视频：已看 {{item.playTimes}} 次</div>
                  </div>
                </li>
              </ul>
            </happy-scroll>
          </div>
        </div>
      </div>
    </div>
    <div class="container clearfix" style="margin-top:2rem;">
      <div class="fl question-wrap">
        <div class="question-title" style="margin-bottom:1rem;">
          共
          <b class="color1">{{questionCount}}</b> 个提问
        </div>
        <question-list @on-loadFinish="setQuestionCount" v-if="updateList" questionType="ppt"></question-list>
      </div>
      <div class="fr question-side">
        <question-ask
          @on-success="submitSuccess"
          position="rev"
          :fromPosition="currentVideoInfo.pptName"
        ></question-ask>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../../components/common/VideoPlayer";
import QuestionAsk from "../../components/exercise/QuestionAsk";
import QuestionList from "../../components/exercise/QuestionList";
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
import { HappyScroll } from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
export default {
  mixins: [siteMixin],
  data() {
    return {
      reviewVideoList: [],
      currentVideoInfo: {},
      courseName: "",
      updateList: true,
      questionCount: 0,
      umcrId: 0,
      isLoaded: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.pptid != from.query.pptid) {
        this.setPptId(to.query.pptid);
        this.changeVideo();
      }
    },
  },
  mounted() {
    this.setMetaData("串讲视频");
    if (!this.initParams()) return;
    this.getCourseName();
    this.getReviewVideoList();
  },
  methods: {
    initParams() {
      let umcId = this.$route.query.umcid;
      let umcrId = this.$route.query.umcrid;
      let pptId = this.$route.query.pptid;
      if (umcId && umcrId && pptId) {
        this.setUmcId(umcId);
        this.umcrId = Number(umcrId);
        this.setPptId(pptId);
        return true;
      } else {
        this.$Message.error("参数错误");
        return false;
      }
    },
    getReviewVideoList() {
      //获取串讲视频及练习题组
      study.getReviewVideoOrExercisList(this.umcrId).then((res) => {
        //console.log("reviewVideo", res);
        this.isLoaded = true;
        if (res.status === 1) {
          this.reviewVideoList = res.data.reviewPptList;
          this.reviewVideoTotalTime = res.data.pptTimeTotal;
          this.changeVideo();
          //this.reviewExerciseList = res.data.reviewExerGroupList;
          //this.reviewExerciseCount = res.data.reviewExerciseCount;
        }
      });
    },
    getCourseName() {
      study.getUmcInfo(this.umcId).then((res) => {
        if (res.status === 1) {
          this.courseName = res.data.courseName;
        }
      });
    },
    changeVideo() {
      let vList = this.reviewVideoList.filter((m) => m.pptId == this.pptId);
      if (vList.length > 0) {
        this.currentVideoInfo = vList[0];
        this.setVideoId(this.currentVideoInfo.bVideoId);
      }
    },
    playOver() {
      console.log("playOver", this.umcrId, this.pptId);
      study.setVideoPlayOverWithReview(this.umcrId, this.pptId).then((res) => {
        console.log(res);
      });
    },
    setQuestionCount(questionList) {
      this.questionCount = questionList.length;
    },
    submitSuccess() {
      this.updateList = false;
      this.$nextTick(() => {
        this.updateList = true;
      });
    },
  },
  components: {
    VideoPlayer,
    HappyScroll,
    QuestionAsk,
    QuestionList,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/exercise.less";
@import "../../assets/css/question.less";
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.video-wrap {
  border: 2px solid #e6e6e6;
  padding: 30px;
  background-color: #fff;
  .video-play {
    width: 770px;
    height: 468px;
    overflow: hidden;
  }
}
.am-margin-top-lg {
  margin-top: 2.4rem;
}
.video-catalog-header {
  /* background-color: #3a3a3a; */
  color: #666;
  /* line-height: 48px; */
  font-size: 1.6rem;
  /* padding: 0 10px; */
  padding-bottom: 10px;
}

.video-catalog-wrap {
  width: 350px;
  height: 435px;
}
.video-fav-list {
  width: 350px;
  /* background: #252525; */
  padding: 0 10px 20px 10px;
}
.video-fav-list li.active {
  background: #efefef;
}
.video-fav-list li {
  font-size: 1.4rem;
  height: 75px;
  /* border-bottom: 1px solid #494949; */
  padding: 10px;
  border-radius: 3px;
  overflow: hidden;
}
.video-fav-list li .title-img {
  width: 96px;
  height: 54px;
  overflow: hidden;
  float: left;
}
.video-fav-list li .title-img img {
  width: 100%;
  height: auto;
}
.video-fav-list li .right-side {
  width: 196px;
  padding-left: 10px;
  height: 54px;
  float: left;
  overflow: hidden;
}
.video-fav-list li.active .right-side .video-title {
  color: #666;
}
.video-fav-list li .right-side .video-title {
  height: 28px;
  line-height: 25px;
  overflow: hidden;
  color: #c8c8c8;
}
.video-fav-list li .right-side .video-attr {
  line-height: 24px;
  height: 24px;
  overflow: hidden;
  color: #969696;
}
.question-wrap {
  width: 860px;
  padding-bottom: 2rem;
  .question-subject {
    margin-bottom: 2rem;
  }
}
.question-side {
  width: 320px;
}
</style>

